import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none text-[#3D3028]/80" data-id="element-278">
      <h3 className="text-lg font-semibold text-[#3D3028] mb-4" data-id="element-279">
        Política de Privacidad
      </h3>

      <p className="mb-4" data-id="element-280">Última actualización: Diciembre 2024</p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-281">
        1. Información que Recopilamos
      </h4>
      <p className="mb-4" data-id="element-282">
        Recopilamos información personal que nos proporcionas voluntariamente al
        registrarte en nuestro curso, incluyendo nombre, correo electrónico y
        datos de pago necesarios para procesar tu compra.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-283">
        2. Uso de la Información
      </h4>
      <p className="mb-4" data-id="element-284">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-285">
        <li data-id="element-286">Procesar tu inscripción y pagos</li>
        <li data-id="element-287">Proporcionar acceso al contenido del curso</li>
        <li data-id="element-288">Enviarte actualizaciones y material educativo</li>
        <li data-id="element-289">Mejorar nuestros servicios</li>
      </ul>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-290">
        3. Protección de Datos
      </h4>
      <p className="mb-4" data-id="element-291">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-292">
        4. Compartir Información
      </h4>
      <p className="mb-4" data-id="element-293">
        No vendemos ni compartimos tu información personal con terceros, excepto
        cuando sea necesario para procesar pagos o cumplir con requisitos
        legales.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-294">
        5. Cookies
      </h4>
      <p className="mb-4" data-id="element-295">
        Utilizamos cookies para mejorar tu experiencia de navegación y analizar
        el uso de nuestro sitio web.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-296">
        6. Tus Derechos
      </h4>
      <p className="mb-4" data-id="element-297">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento.
      </p>

      <h4 className="text-base font-semibold text-[#3D3028] mt-6 mb-3" data-id="element-298">
        7. Cambios a esta Política
      </h4>
      <p className="mb-4" data-id="element-299">
        Nos reservamos el derecho de actualizar esta política de privacidad. Te
        notificaremos sobre cambios significativos mediante correo electrónico.
      </p>
    </div>;
}